import {paramsFilter} from "@/utils/global";
import axios from "axios";
import Api from "../api";
import vue from "../main";
import store from "../stroe/index";
import local from "./localStroage.js";
import config from "./serverUrlConfig";
// 创建一个axios实例
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 120000,
});

// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
instance.setToken = (token) => {
    instance.defaults.headers["Authorization"] = token;
    local.setItem("token", token);
};
instance.defaults.headers.post["Content-Type"] =
    "application/json; charset=utf-8";

function refreshToken() {
    // instance是当前request.js中已创建的axios实例
    return Api.refreshToken().then((res) => res);
}

// 是否正在重新登陆
let isLogining = false;
// 下次调用接口需要刷新的标识
let needRefresh = false;
// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];

// 设置请求拦截器，将token传入header传递给后端
instance.interceptors.request.use(
    (config) => {
        let token = local.get("userInfo") ? local.get("userInfo").token : "",
            storeToken = vue.$store.state.token;
        if (storeToken !== token) {
            vue.$store.dispatch("setToken", token);
        }
        if (token) {
            config.headers["Authorization"] = token;
        }
        if (config.url.endsWith("refresh")) {
            return config;
        }
        if (needRefresh) {
            if (!isRefreshing) {
                // eslint-disable-next-line no-const-assign
                isRefreshing = true;
                return refreshToken()
                    .then((res) => {
                        const {token} = res.data;
                        let userInfo = local.get("userInfo") ? local.get("userInfo") : {};
                        userInfo = Object.assign(userInfo, {token: token});
                        vue.$store.dispatch("setToken", token);
                        local.set("userInfo", userInfo);

                        config.headers["Authorization"] = token;
                        isRefreshing = false;
                        needRefresh = false;
                        // 已经刷新了token，将所有队列中的请求进行重试
                        requests.forEach((cb) => cb(token));
                        requests = [];
                        return config;
                    })
                    .catch(() => {
                        isRefreshing = false;
                        needRefresh = false;
                    })
                    .finally(() => {
                        //console.log('刷新事件结束')
                    });
            } else {
                // 正在刷新token，将返回一个未执行resolve的promise
                return new Promise((resolve) => {
                    // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                    requests.push((token) => {
                        config.headers["Authorization"] = token;
                        resolve(instance(config));
                    });
                });
            }
        }
        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        if (response.headers["refresh-authorization"] === "true" && !isRefreshing) {
            needRefresh = true;
        }
        switch (response.data.code) {
            case 1003:
                if (!isLogining) {
                    isLogining = true;
                    if (store.state.confirmFlag) {
                        vue
                            .$confirm("登陆信息已失效,请重新登陆!", "退出提示", {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning",
                            })
                            .then(() => {
                                local.remove("userInfo");
                                local.remove("role");
                                vue.$store.dispatch("removeAllTag");
                                vue.$store.dispatch("setConfirmFlag");
                                isLogining = false;
                                vue.$router.push("/login");
                            })
                            .catch(() => {
                                return Promise.reject(new Error("取消返回登陆页面"));
                            })
                            .finally(() => {
                                isLogining = false;
                            });
                    }
                }
                break;
            case 200:
                return Promise.resolve(response.data);
            default:
                if (response.data.tip) {
                    vue.$message.error(response.data.tip);
                    throw new Error(response.data.tip);
                } else {
                    return Promise.resolve(response.data);
                }
            //case 200:
            //  return Promise.resolve(response.data)
            //default:
            //  vue.$message.error(response.data.tip)
            //  return Promise.reject(response.data.tip)
        }
        return Promise.resolve(response.data);
    },
    (error) => {
        return Promise.reject(error);
    }
);

const ajax = (param) => {
    // 定义内部默认请求对象
    let defaultParam = {
        url: "",
        type: "get",
        params: {},
    };

    if (param.url !== "/vid/uploadStatic" && param.params) {
        param.params = paramsFilter(param.params);
    }

    // 合并请求参数
    let newParams = Object.assign(defaultParam, param);
    // 设置公共请求地址、超时时间
    defaultParam.url = config.baseServerUrl + defaultParam.url;




    instance.defaults.timeout = 1000 * 60;
    // 返回一个ajax对象
    return new Promise((resolve, reject) => {
        // 处理post、get不同请求时参数处理
        let getParams, postParams;
        if (newParams.type === "get") {
            getParams = newParams.params;
        } else {
            postParams = newParams.params;
        }
        instance({
            url: newParams.url,
            method: newParams.type,
            data: postParams,
            params: getParams,
            // headers:param.headers,
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            // headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
export default ajax;
